import { StanTag, StanTooltip } from '@/components';
import { createIconElement } from '@/lib/utils/createIconElement';
import IconHelp from '@/assets/icons/ic-help-circle.svg';

interface TaxRegistrationsProps {
    tags: string[];
}

export const TaxRegistrations = ({ tags }: TaxRegistrationsProps) => (
    <div>
        <div className='mb-1 flex items-center gap-1'>
            <div className='text-label-sm-bold'>Tax Registrations</div>
            <StanTooltip
                className='w-full'
                content='Need to edit your registrations? Email us at friends@stanwith.me'
                position='top'
            >
                {createIconElement(IconHelp, { className: 'text-brand-main size-3 cursor-help' })}
            </StanTooltip>
        </div>
        <p className='text-caption-2-regular text-gray mb-2'>
            Based on your Tax Address, we&apos;ve enrolled you to collect tax in these locations:
        </p>
        <div className='flex flex-wrap gap-2'>
            {tags.length > 0 ? (
                tags.map(tag => <StanTag key={tag} label={tag} className='bg-neutral-dimmed text-brand-main' />)
            ) : (
                <span className='text-caption-2-regular text-gray'>No registrations yet</span>
            )}
        </div>
    </div>
);
